const TRUST_PAGE_ROUTES = {
  '/about': 'about',
  '/privacy-policy': 'privacyPolicy',
  '/contact': 'contact',
  '/disclaimer': 'disclaimer'
};

const CONTENT_ROUTES = {
  '/': 'home',
  '/pvp': 'pvp',
  '/guildWarCount': 'guildWarCount',
  '/rangers-book': 'rangersBook',
  '/raid-hitting-characters': 'raidHittingCharacters',
  ...TRUST_PAGE_ROUTES
};

const sharedContactUrl = 'https://x.com/banana_chan3';

const publicContent = {
  ja: {
    pages: {
      home: {
        summaryLabel: 'このサイトの説明を読む',
        sections: [
          {
            title: 'このサイトで分かること',
            paragraphs: [
              'LINEレンジャー Analyticsは、ギルド戦とPVPで実際に使われているレンジャー、装備、攻撃状況を整理する非公式のデータ分析サイトです。ランキング表だけでなく、上位帯で採用されている防衛レンジャーや装備の偏りを比較し、編成やギルド運用を考える材料として使えるようにしています。',
              '公開ページでは、PVP使用率、ギルド戦攻撃チェック、Ranger図鑑リンクを中心に、プレイヤーが繰り返し確認する情報をまとめています。各データはゲーム内の状況や取得タイミングにより変動するため、最終判断はゲーム内表示と合わせて確認してください。'
            ]
          },
          {
            title: '独自性と更新方針',
            paragraphs: [
              'このサイトの価値は、ゲーム画像そのものではなく、複数のデータを集計して見やすく並べ、PVPやギルド戦で判断しやすい形にする点にあります。レンジャーや装備の画像は識別を助ける補助情報として表示し、主な内容は使用数、順位、更新日、操作説明、分析コメントです。',
              'データは定期的に更新されますが、API応答や外部サービスの状態によって反映が遅れることがあります。古い情報や誤りに気付いた場合は、フッターの連絡先から知らせてください。'
            ]
          }
        ],
        summaryLinksTitle: '主要ページの使い分け'
      },
      pvp: {
        summaryLabel: 'PVPページの説明を読む',
        sections: [
          {
            title: 'PVPランキングの読み方',
            paragraphs: [
              'このページでは、PVP上位プレイヤーの防衛Rangerと装備使用数をランク別に集計しています。LEGEND、MASTER、DIAMONDなどのランクを切り替えることで、上位帯全体の傾向と特定ランクの傾向を分けて確認できます。',
              '使用数が多いRangerは、現在の防衛編成で採用されやすい候補です。ただし、使用数は強さを直接保証するものではありません。環境、相性、装備、プレイヤーの育成状況によって有効性は変わるため、複数のランクや装備データを合わせて見ることをおすすめします。'
            ]
          },
          {
            title: '装備トレンドの活用方法',
            paragraphs: [
              'Ranger画像を選択すると、対象Rangerに使われている装備例を確認できます。武器、防具、アクセサリーの採用傾向を見ることで、単に人気Rangerを知るだけでなく、どの役割で使われているかを推測しやすくなります。',
              '集計結果は数分単位で更新されることがあります。読み込み中は古い表や空の状態に見える場合があるため、時間を置いて再読み込みしてください。'
            ]
          }
        ]
      },
      guildWarCount: {
        summaryLabel: '攻撃チェックの説明を読む',
        sections: [
          {
            title: '攻撃回数チェックの目的',
            paragraphs: [
              'ギルド戦攻撃回数チェッカーは、味方と敵チームの攻撃状況を確認し、未消化攻撃を管理するための補助ツールです。自動で攻撃を判定する機能ではなく、ギルドメンバーが攻撃後に状況を確認しながら使う運用支援ページです。',
              '攻撃残数を一覧で見られるため、終盤に誰の攻撃が残っているか、どちらのチームに確認が必要かを把握しやすくなります。ギルド内の連絡や指示出しと合わせて利用してください。'
            ]
          },
          {
            title: '使い方と注意点',
            paragraphs: [
              '国、ギルド、味方/敵の条件を選ぶと、対象チームのメンバーと攻撃状況を確認できます。データの取得には時間がかかる場合があり、ゲーム側の更新タイミングによって表示が最新でないことがあります。',
              'このページの情報は戦略判断の補助です。重要な対戦では、ゲーム内の表示、ギルドチャット、実際の攻撃結果と照らし合わせて確認してください。'
            ]
          }
        ]
      },
      rangersBook: {
        summaryLabel: 'Ranger図鑑の説明を読む',
        sections: [
          {
            title: 'Ranger図鑑リンクの使い方',
            paragraphs: [
              'Ranger図鑑では、RangerのリソースID、更新日、サムネイルを一覧で確認し、詳細ページへ移動できます。IDや更新日をまとめて見ることで、新規追加や更新されたRangerを探しやすくしています。',
              'サムネイル画像はRangerを識別しやすくするための補助表示です。このページの主な目的は、画像を転載することではなく、更新順やIDを整理してプレイヤーが必要な詳細情報へ移動しやすくすることです。'
            ]
          },
          {
            title: 'データの見方',
            paragraphs: [
              '一覧に表示される日付は、取得できたリソース情報に基づく更新日の目安です。ゲーム内の実装日や性能変更日と完全に一致しない場合があります。',
              '画像が表示されない項目は、外部リソースの取得制限、未配信データ、URL変更などが原因の可能性があります。必要に応じて詳細リンクやゲーム内情報を確認してください。'
            ]
          }
        ]
      },
      raidHittingCharacters: {
        title: 'レイドボスにヒットするスキル一覧',
        lead: 'レイドボスに有効なスキルを持つRangerを一覧で確認できる公開データページです。',
        summaryLabel: 'レイドヒット判定の説明を読む',
        sections: [
          {
            title: 'このページで分かること',
            paragraphs: [
              'このページでは、レイド対象に効果があるスキルを持つRangerを一覧化しています。スタン、無敵解除、スキル抵抗ダウンなど、レイド攻略で確認したい効果をキャラクターごとに整理しています。',
              'スキルの中でも範囲ダメージ系のスキルはレイドボスにヒットします。一方で、デバフ系スキルはすべてが当たるわけではなく、レイドボスに当たるよう設定されている一部のスキルだけが対象です。',
              '単なる図鑑ではなく、レイド関連データから抽出したスキル情報をまとめたページです。編成候補を探すときや、手持ちRangerの役割を確認するときに使えます。',
              '同じRangerでも進化段階によって判定が異なる場合があります。超進化のスキルはレイドボスにヒットする一方で、究極進化のスキルはヒットしないRangerも存在します（例: エレン、ギターリストムーン等）。'
            ]
          },
          {
            title: 'データの注意点',
            paragraphs: [
              '表示されるスキルは収集済みデータをもとに整理しています。ゲーム側の更新、取得タイミング、未収集データにより、最新状態と差が出る場合があります。',
              '画像はRangerを識別するための補助表示です。重要な判断はゲーム内情報や最新の公式表示と合わせて確認してください。'
            ]
          }
        ]
      },
      about: {
        title: 'About',
        lead: 'LINE Rangers Analyticsは、LINE Rangersプレイヤー向けの非公式データ分析サイトです。',
        sections: [
          {
            title: '運営目的',
            paragraphs: [
              'このサイトは、PVPやギルド戦で使われるRanger、装備、攻撃状況を整理し、プレイヤーが編成やギルド運用を考えるときの参考情報を提供するために運営しています。',
              '公式ニュースやゲーム内表示を置き換えるものではなく、プレイヤー視点でデータを見やすくまとめる補助サイトです。'
            ]
          },
          {
            title: 'データについて',
            paragraphs: [
              '掲載しているランキングや一覧は、取得できたデータを集計・整理したものです。取得タイミング、API応答、ゲーム内更新により、実際の状態と差が出る場合があります。',
              'LINE Rangers、関連する名称、画像、商標、著作物の権利は各権利者に帰属します。このサイトはLINE、LY Corporation、LINE Rangers運営元とは関係ありません。'
            ]
          }
        ]
      },
      privacyPolicy: {
        title: 'プライバシーポリシー',
        lead: 'このページでは、当サイトで扱うアクセス情報、Cookie、広告、外部サービスについて説明します。',
        sections: [
          {
            title: 'アクセス解析とログ',
            paragraphs: [
              '当サイトでは、ページ改善や不具合調査のために、アクセス日時、閲覧ページ、ブラウザ、OS、端末種別、IPアドレスなどの技術情報を取得する場合があります。これらは個人を直接特定する目的では使用しません。',
              'また、Google Analyticsなどの解析サービスを利用する場合があります。解析サービスはCookieなどを使用し、利用状況を集計することがあります。'
            ]
          },
          {
            title: '広告とCookie',
            paragraphs: [
              '当サイトではGoogle AdSenseなどの第三者配信広告を利用する場合があります。広告配信事業者は、ユーザーの興味に応じた広告を表示するため、Cookie、Webビーコン、IPアドレス、その他の識別子を使用することがあります。',
              'Googleによるデータ利用については、Googleの「Google のサービスを使用するサイトやアプリから収集した情報の Google による使用」を確認してください。ユーザーはブラウザ設定やGoogle広告設定からCookieやパーソナライズ広告を管理できます。'
            ]
          },
          {
            title: 'お問い合わせ',
            paragraphs: [
              '掲載内容、権利、プライバシーに関する問い合わせは、Contactページの連絡先からお願いします。必要に応じて内容の修正や削除を検討します。'
            ]
          }
        ]
      },
      contact: {
        title: 'Contact',
        lead: 'お問い合わせ、更新情報、掲載内容の修正依頼は以下の連絡先からお願いします。',
        sections: [
          {
            title: '連絡先',
            paragraphs: [
              `通常の問い合わせや更新情報はXで受け付けています: ${sharedContactUrl}`,
              '掲載内容の誤り、削除依頼、権利に関する連絡は、対象URL、問題の内容、確認できる情報を添えて連絡してください。'
            ]
          },
          {
            title: '対応について',
            paragraphs: [
              'すべての問い合わせに返信できるとは限りませんが、サイトの品質改善、誤情報の修正、権利者からの申し出には優先して対応します。',
              '広告クリック依頼、広告表示の操作、ランキング操作に関する依頼には対応しません。'
            ]
          }
        ],
        linkLabel: 'Xで問い合わせる'
      },
      disclaimer: {
        title: '免責事項',
        lead: '当サイトの位置づけ、権利表記、掲載情報の扱いについて説明します。',
        sections: [
          {
            title: '非公式サイトについて',
            paragraphs: [
              '当サイトはLINE Rangersの非公式ファン向け分析サイトです。LINE、LY Corporation、LINE Rangers運営元、その他公式パートナーとは関係ありません。',
              'ゲーム名、キャラクター名、画像、商標、その他関連する権利は各権利者に帰属します。サイト内の画像は識別や説明の補助として表示しています。'
            ]
          },
          {
            title: '情報の正確性',
            paragraphs: [
              '掲載しているデータや分析は、取得できた情報に基づいて作成していますが、正確性、完全性、最新性を保証するものではありません。',
              'このサイトの情報を利用したことによるゲーム内の結果、ギルド運用上の判断、その他の損害について、運営者は責任を負いません。重要な判断はゲーム内の公式表示と合わせて確認してください。'
            ]
          }
        ]
      }
    }
  },
  en: {
    pages: {
      home: {
        summaryLabel: 'Read about this site',
        sections: [
          {
            title: 'What This Site Provides',
            paragraphs: [
              'LINE Rangers Analytics is an unofficial data site that organizes Ranger usage, equipment trends, and guild war activity for LINE Rangers players. It is designed to help players compare what is being used in PVP and guild war instead of relying on scattered screenshots or chat messages.',
              'The public pages focus on PVP usage rankings, guild war attack checking, and Ranger resource links. Data can change depending on game updates and collection timing, so important decisions should also be checked against the in-game display.'
            ]
          },
          {
            title: 'Original Value and Updates',
            paragraphs: [
              'The value of this site is not the game artwork itself. The value is the curated data structure: usage counts, rankings, update dates, filters, and explanations that make it easier to understand current trends.',
              'Ranger and equipment images are used only as supporting identifiers. The main content is the organized data, instructions, and analysis context. If you find stale or incorrect information, please use the contact link in the footer.'
            ]
          }
        ],
        summaryLinksTitle: 'Main tools'
      },
      pvp: {
        summaryLabel: 'Read the PVP page guide',
        sections: [
          {
            title: 'How to Read the PVP Rankings',
            paragraphs: [
              'This page counts defense Rangers and equipment used by higher-ranked PVP players. By switching between LEGEND, MASTER, and DIAMOND ranks, you can compare broad trends against the behavior of a specific rank range.',
              'A high usage count means that a Ranger is frequently selected in current defense teams, but it does not guarantee that the Ranger is always the strongest choice. Team role, equipment, counters, and your own upgrade level still matter.'
            ]
          },
          {
            title: 'Using Equipment Trends',
            paragraphs: [
              'Selecting a Ranger image opens equipment examples for that Ranger. Looking at weapon, armor, and accessory patterns helps explain how the Ranger is being used, not just whether it is popular.',
              'The data may refresh every few minutes. If the page is loading, empty, or appears stale, reload it after a short wait and compare several ranks before making a decision.'
            ]
          }
        ]
      },
      guildWarCount: {
        summaryLabel: 'Read the attack checker guide',
        sections: [
          {
            title: 'Purpose of the Attack Checker',
            paragraphs: [
              'The guild war attack checker helps guilds review remaining attacks for ally and enemy teams. It is a manual operations aid, not an automatic battle detector.',
              'The page is useful near the end of a guild war round, when leaders need to know who still has attacks available and which team needs follow-up in chat.'
            ]
          },
          {
            title: 'How to Use It Safely',
            paragraphs: [
              'Choose the country, guild, and ally/enemy side to review the relevant members and attack state. Data collection can take time, and game-side updates may not appear immediately.',
              'Treat this page as a planning aid. For important matches, confirm the result with the in-game screen, guild chat, and the actual attack history.'
            ]
          }
        ]
      },
      rangersBook: {
        summaryLabel: 'Read the Ranger Book guide',
        sections: [
          {
            title: 'How to Use the Ranger Book Links',
            paragraphs: [
              'The Ranger Book page lists Ranger resource IDs, approximate update dates, thumbnails, and links to detailed pages. This makes it easier to find newly added or recently updated Rangers.',
              'Thumbnails are supporting identifiers. The purpose of the page is to organize IDs and update signals so players can reach the right detailed information faster.'
            ]
          },
          {
            title: 'Reading the Data',
            paragraphs: [
              'Dates are based on available resource information and may not exactly match the in-game release date or balance adjustment date.',
              'If an image is missing, the external resource may be unavailable, blocked, unpublished, or moved. Use the detail link and in-game information when needed.'
            ]
          }
        ]
      },
      raidHittingCharacters: {
        title: 'Raid-Hitting Rangers',
        lead: 'A public data page listing Rangers with skills that can affect raid targets.',
        summaryLabel: 'Read how raid-hit data is judged',
        sections: [
          {
            title: 'What This Page Shows',
            paragraphs: [
              'This page lists Rangers that have skills relevant to raid targets, such as stun, invincibility removal, skill resistance reduction, and similar effects.',
              'It is not just a visual catalog. The page organizes extracted raid-related skill data so players can find candidates for raid team building and understand what role each Ranger may cover.',
              'Raid-hit behavior can also differ by evolution stage. Some Rangers have hyper-evolved skills that hit raid bosses while their ultimate-evolved skills do not, such as Eren and Guitarist Moon.'
            ]
          },
          {
            title: 'Data Notes',
            paragraphs: [
              'The list is based on collected data and may differ from the latest game state depending on game updates, collection timing, or missing data.',
              'Images are shown only as supporting identifiers. Confirm important decisions with the in-game display and current official information.'
            ]
          }
        ]
      },
      about: {
        title: 'About',
        lead: 'LINE Rangers Analytics is an unofficial data analysis site for LINE Rangers players.',
        sections: [
          {
            title: 'Purpose',
            paragraphs: [
              'This site organizes Ranger usage, equipment trends, and guild war activity so players can make better decisions for PVP and guild operations.',
              'It does not replace official announcements or the in-game display. It is a player-focused tool that makes collected data easier to read.'
            ]
          },
          {
            title: 'Data and Affiliation',
            paragraphs: [
              'Rankings and lists are based on data that could be collected and organized. They may differ from the current game state depending on timing, API responses, or game updates.',
              'LINE Rangers, related names, images, trademarks, and copyrighted works belong to their respective owners. This site is not affiliated with LINE, LY Corporation, or the LINE Rangers team.'
            ]
          }
        ]
      },
      privacyPolicy: {
        title: 'Privacy Policy',
        lead: 'This page explains access logs, cookies, ads, analytics, and external services used by this site.',
        sections: [
          {
            title: 'Analytics and Logs',
            paragraphs: [
              'This site may collect technical information such as access time, viewed page, browser, OS, device type, and IP address for improvement and troubleshooting. This information is not used to directly identify individual visitors.',
              'The site may use analytics services such as Google Analytics. These services may use cookies or similar technologies to measure site usage.'
            ]
          },
          {
            title: 'Advertising and Cookies',
            paragraphs: [
              'This site may use third-party advertising services such as Google AdSense. Advertising partners may use cookies, web beacons, IP addresses, and other identifiers to serve and measure ads.',
              'For information about how Google uses data from partner sites and apps, please review Google’s explanation of partner data usage. Users can manage cookies and personalized ads through browser settings and Google ad settings.'
            ]
          },
          {
            title: 'Contact',
            paragraphs: [
              'For questions about content, rights, or privacy, please use the contact page. We will review requests to correct, remove, or hide content when appropriate.'
            ]
          }
        ]
      },
      contact: {
        title: 'Contact',
        lead: 'Use this page for questions, update information, corrections, and rights-related requests.',
        sections: [
          {
            title: 'Contact Method',
            paragraphs: [
              `General questions and update information are handled on X: ${sharedContactUrl}`,
              'For corrections, removals, or rights-related requests, include the target URL, the issue, and any information that helps verify the request.'
            ]
          },
          {
            title: 'Response Policy',
            paragraphs: [
              'We may not be able to reply to every message, but we prioritize site quality issues, incorrect information, and requests from rights holders.',
              'We do not respond to requests for ad clicks, ad manipulation, or ranking manipulation.'
            ]
          }
        ],
        linkLabel: 'Contact on X'
      },
      disclaimer: {
        title: 'Disclaimer',
        lead: 'This page explains the site status, rights notices, and limits of the information provided.',
        sections: [
          {
            title: 'Unofficial Site',
            paragraphs: [
              'This is an unofficial fan-made analytics site for LINE Rangers. It is not affiliated with, endorsed by, or sponsored by LINE, LY Corporation, the LINE Rangers team, or any official partner.',
              'Game names, character names, images, trademarks, and other related rights belong to their respective owners. Images are shown as supporting identifiers for explanation and navigation.'
            ]
          },
          {
            title: 'Accuracy',
            paragraphs: [
              'The data and analysis on this site are based on information that could be collected, but accuracy, completeness, and freshness are not guaranteed.',
              'The operator is not responsible for in-game results, guild operation decisions, or other damages caused by using this site. Please confirm important information with the official in-game display.'
            ]
          }
        ]
      }
    }
  }
};

publicContent.ko = {
  pages: {
      home: {
      summaryLabel: '이 사이트 설명 보기',
      sections: [
        {
          title: '이 사이트에서 확인할 수 있는 것',
          paragraphs: [
            '라인 레인저스 Analytics는 길드전과 PVP에서 실제로 사용되는 레인저, 장비, 공격 현황을 정리하는 비공식 데이터 분석 사이트입니다. 단순한 표가 아니라 상위권에서 어떤 방어 레인저와 장비가 많이 쓰이는지 비교해 편성 판단에 활용할 수 있도록 구성했습니다.',
            '공개 페이지는 PVP 사용률, 길드전 공격 체크, Ranger 도감 링크를 중심으로 반복해서 확인해야 하는 정보를 모았습니다. 데이터는 수집 시점과 게임 업데이트에 따라 달라질 수 있으므로 중요한 판단은 게임 내 표시와 함께 확인해 주세요.'
          ]
        },
        {
          title: '독자적 가치와 업데이트',
          paragraphs: [
            '이 사이트의 핵심 가치는 게임 이미지가 아니라 여러 데이터를 집계하고 보기 쉬운 형태로 정리하는 데 있습니다. 레인저와 장비 이미지는 식별을 돕는 보조 정보이며, 주요 콘텐츠는 사용 수, 순위, 업데이트 날짜, 사용 설명, 분석 맥락입니다.',
            '데이터는 정기적으로 갱신되지만 API 응답이나 외부 서비스 상태에 따라 반영이 늦어질 수 있습니다. 오래된 정보나 오류를 발견하면 푸터의 연락처로 알려 주세요.'
          ]
        }
      ],
      summaryLinksTitle: '주요 페이지'
    },
    pvp: {
      summaryLabel: 'PVP 페이지 설명 보기',
      sections: [
        {
          title: 'PVP 랭킹 읽는 방법',
          paragraphs: [
            '이 페이지는 PVP 상위 플레이어의 방어 Ranger와 장비 사용 수를 랭크별로 집계합니다. LEGEND, MASTER, DIAMOND를 전환하면 전체 상위권 흐름과 특정 랭크의 흐름을 나누어 볼 수 있습니다.',
            '사용 수가 높다는 것은 현재 방어 편성에서 자주 채택된다는 뜻이지만, 항상 가장 강하다는 의미는 아닙니다. 역할, 장비, 상성, 육성 상태를 함께 고려해야 합니다.'
          ]
        },
        {
          title: '장비 트렌드 활용',
          paragraphs: [
            'Ranger 이미지를 선택하면 해당 Ranger에 사용된 장비 예시를 확인할 수 있습니다. 무기, 방어구, 액세서리 패턴을 보면 인기 여부뿐 아니라 어떤 역할로 쓰이는지도 추정하기 쉬워집니다.',
            '데이터는 몇 분 단위로 갱신될 수 있습니다. 로딩 중이거나 비어 보일 때는 잠시 후 새로고침하고 여러 랭크를 비교해 보세요.'
          ]
        }
      ]
    },
    guildWarCount: {
      summaryLabel: '공격 체크 설명 보기',
      sections: [
        {
          title: '공격 체크 도구의 목적',
          paragraphs: [
            '길드전 공격 횟수 체크 도구는 아군과 적 팀의 남은 공격을 확인하기 위한 운영 보조 도구입니다. 자동 전투 감지 기능이 아니라 길드원이 공격 후 직접 확인하며 사용하는 페이지입니다.',
            '라운드 종료 전 누가 공격을 남겼는지, 어느 팀에 확인이 필요한지 빠르게 파악할 수 있어 길드 채팅과 지시 운영에 도움이 됩니다.'
          ]
        },
        {
          title: '사용 방법과 주의점',
          paragraphs: [
            '국가, 길드, 아군/적 조건을 선택하면 대상 멤버와 공격 상태를 확인할 수 있습니다. 데이터 수집에는 시간이 걸릴 수 있고 게임 쪽 갱신이 즉시 반영되지 않을 수 있습니다.',
            '이 정보는 전략 판단을 돕기 위한 참고 자료입니다. 중요한 전투에서는 게임 내 화면, 길드 채팅, 실제 공격 결과를 함께 확인해 주세요.'
          ]
        }
      ]
    },
    rangersBook: {
      summaryLabel: 'Ranger 도감 설명 보기',
      sections: [
        {
          title: 'Ranger 도감 링크 사용법',
          paragraphs: [
            'Ranger 도감은 리소스 ID, 업데이트 날짜, 썸네일을 목록으로 보여주고 상세 페이지로 이동할 수 있게 합니다. 새로 추가되었거나 갱신된 Ranger를 찾기 쉽게 만드는 것이 목적입니다.',
            '썸네일은 식별을 돕기 위한 보조 표시입니다. 이 페이지의 주된 가치는 이미지를 나열하는 것이 아니라 ID와 업데이트 신호를 정리해 필요한 상세 정보로 빠르게 이동하게 하는 데 있습니다.'
          ]
        },
        {
          title: '데이터 보는 법',
          paragraphs: [
            '표시되는 날짜는 확인 가능한 리소스 정보에 기반한 업데이트 시점의 참고값입니다. 게임 내 출시일이나 밸런스 조정일과 완전히 일치하지 않을 수 있습니다.',
            '이미지가 표시되지 않는 항목은 외부 리소스 제한, 미공개 데이터, URL 변경 때문일 수 있습니다. 필요한 경우 상세 링크와 게임 내 정보를 확인하세요.'
          ]
        }
      ]
    },
    raidHittingCharacters: {
      title: '레이드에 히트하는 캐릭터',
      lead: '레이드 대상에 효과가 있는 스킬을 가진 Ranger를 확인할 수 있는 공개 데이터 페이지입니다.',
      summaryLabel: '레이드 히트 판정 설명 보기',
      sections: [
        { title: '이 페이지에서 확인할 수 있는 것', paragraphs: ['스턴, 무적 해제, 스킬 저항 감소 등 레이드에서 확인하고 싶은 효과를 가진 Ranger를 정리합니다.', '이미지 목록이 아니라 레이드 관련 데이터에서 추출한 스킬 정보를 캐릭터별로 정리해 편성 후보와 역할을 찾기 쉽게 만든 페이지입니다.', '같은 Ranger라도 진화 단계에 따라 판정이 다를 수 있습니다. 초진화 스킬은 레이드 보스에 히트하지만 궁극진화 스킬은 히트하지 않는 Ranger도 있습니다. 예: 에렌, 기타리스트 문 등.'] },
        { title: '데이터 주의점', paragraphs: ['표시되는 스킬은 수집된 데이터를 기준으로 하며, 게임 업데이트나 수집 시점에 따라 최신 상태와 다를 수 있습니다.', '이미지는 Ranger 식별을 돕는 보조 표시입니다. 중요한 판단은 게임 내 정보와 함께 확인해 주세요.'] }
      ]
    },
    about: {
      title: 'About',
      lead: 'LINE Rangers Analytics는 LINE Rangers 플레이어를 위한 비공식 데이터 분석 사이트입니다.',
      sections: [
        { title: '운영 목적', paragraphs: ['PVP와 길드전에서 사용되는 Ranger, 장비, 공격 현황을 정리해 편성과 길드 운영 판단에 도움이 되는 정보를 제공합니다.', '공식 공지나 게임 내 표시를 대체하지 않으며, 플레이어 관점에서 데이터를 읽기 쉽게 정리하는 보조 사이트입니다.'] },
        { title: '데이터와 관계', paragraphs: ['랭킹과 목록은 수집 가능한 데이터를 집계한 것이며 수집 시점, API 응답, 게임 업데이트에 따라 실제 상태와 다를 수 있습니다.', 'LINE Rangers와 관련 명칭, 이미지, 상표, 저작물의 권리는 각 권리자에게 있습니다. 이 사이트는 LINE, LY Corporation, LINE Rangers 운영팀과 관계가 없습니다.'] }
      ]
    },
    privacyPolicy: {
      title: '개인정보 처리방침',
      lead: '이 페이지는 접속 정보, Cookie, 광고, 분석 서비스 사용에 대해 설명합니다.',
      sections: [
        { title: '분석과 로그', paragraphs: ['사이트 개선과 오류 조사를 위해 접속 시간, 열람 페이지, 브라우저, OS, 기기 종류, IP 주소 등의 기술 정보를 수집할 수 있습니다. 이 정보는 개인을 직접 식별하기 위한 목적으로 사용하지 않습니다.', 'Google Analytics 등의 분석 서비스를 사용할 수 있으며, 해당 서비스는 Cookie 등을 사용해 이용 상황을 집계할 수 있습니다.'] },
        { title: '광고와 Cookie', paragraphs: ['Google AdSense 같은 제3자 광고 서비스를 사용할 수 있습니다. 광고 사업자는 관심 기반 광고 표시와 측정을 위해 Cookie, 웹 비콘, IP 주소, 기타 식별자를 사용할 수 있습니다.', '사용자는 브라우저 설정과 Google 광고 설정에서 Cookie 및 개인 맞춤 광고를 관리할 수 있습니다.'] },
        { title: '문의', paragraphs: ['콘텐츠, 권리, 개인정보 관련 문의는 Contact 페이지의 연락처를 이용해 주세요. 필요한 경우 수정, 삭제, 비공개 처리를 검토합니다.'] }
      ]
    },
    contact: {
      title: 'Contact',
      lead: '문의, 업데이트 정보, 수정 요청은 아래 연락처를 이용해 주세요.',
      sections: [
        { title: '연락 방법', paragraphs: [`일반 문의와 업데이트 정보는 X에서 받습니다: ${sharedContactUrl}`, '수정, 삭제, 권리 관련 요청은 대상 URL, 문제 내용, 확인 가능한 정보를 함께 보내 주세요.'] },
        { title: '대응 방침', paragraphs: ['모든 메시지에 답변할 수는 없지만, 사이트 품질 문제, 잘못된 정보, 권리자 요청은 우선적으로 확인합니다.', '광고 클릭 요청, 광고 조작, 랭킹 조작 요청에는 대응하지 않습니다.'] }
      ],
      linkLabel: 'X에서 문의하기'
    },
    disclaimer: {
      title: '면책 사항',
      lead: '사이트의 위치, 권리 표기, 정보 이용의 한계를 설명합니다.',
      sections: [
        { title: '비공식 사이트', paragraphs: ['이 사이트는 LINE Rangers의 비공식 팬 분석 사이트입니다. LINE, LY Corporation, LINE Rangers 운영팀 또는 공식 파트너와 관계가 없습니다.', '게임명, 캐릭터명, 이미지, 상표 등 관련 권리는 각 권리자에게 있습니다. 이미지는 설명과 탐색을 위한 보조 식별 정보로 표시됩니다.'] },
        { title: '정확성', paragraphs: ['사이트의 데이터와 분석은 수집 가능한 정보에 기반하지만 정확성, 완전성, 최신성을 보장하지 않습니다.', '이 사이트 이용으로 인한 게임 내 결과, 길드 운영 판단, 기타 손해에 대해 운영자는 책임을 지지 않습니다. 중요한 정보는 게임 내 공식 표시와 함께 확인해 주세요.'] }
      ]
    }
  }
};

publicContent['zh-tw'] = {
  pages: {
    home: {
      summaryLabel: '閱讀網站說明',
      sections: [
        { title: '這個網站能提供什麼', paragraphs: ['LINE Rangers Analytics 是整理公會戰與 PVP 實際使用 Ranger、裝備、攻擊狀態的非官方資料分析網站。它不只是表格，而是讓玩家比較上位玩家的防守 Ranger 與裝備傾向，作為編隊與公會營運的參考。', '公開頁面集中在 PVP 使用率、公會戰攻擊檢查、Ranger 圖鑑連結。資料會因遊戲更新與取得時間而變動，重要判斷仍請搭配遊戲內畫面確認。'] },
        { title: '獨特價值與更新方式', paragraphs: ['本站的價值不是遊戲圖片本身，而是把多種資料彙整、排序並以容易理解的方式呈現。Ranger 與裝備圖片只是輔助識別，主要內容是使用數、排名、更新日期、操作說明與分析脈絡。', '資料會定期更新，但 API 回應或外部服務狀態可能造成延遲。若發現過期或錯誤資訊，請透過頁尾聯絡方式告知。'] }
      ],
      summaryLinksTitle: '主要頁面'
    },
    pvp: {
      summaryLabel: '閱讀 PVP 頁面說明',
      sections: [
        { title: '如何閱讀 PVP 排名', paragraphs: ['此頁依照排名區間統計 PVP 上位玩家的防守 Ranger 與裝備使用數。切換 LEGEND、MASTER、DIAMOND 後，可以分別觀察整體上位環境與特定排名區間的差異。', '使用數高代表該 Ranger 在目前防守隊伍中常被採用，但不等於永遠最強。角色定位、裝備、剋制關係與自己的培育狀態都需要一起考慮。'] },
        { title: '如何使用裝備趨勢', paragraphs: ['選擇 Ranger 圖片後，可以查看該 Ranger 的裝備範例。觀察武器、防具、飾品的搭配，有助於理解它在隊伍中的角色，而不只是知道它是否熱門。', '資料可能每隔數分鐘更新。若頁面載入中、空白或看起來不新，請稍後重新整理並比較多個排名區間。'] }
      ]
    },
    guildWarCount: {
      summaryLabel: '閱讀攻擊檢查說明',
      sections: [
        { title: '攻擊檢查工具的目的', paragraphs: ['公會戰攻擊次數檢查工具用來協助確認我方與敵方隊伍的剩餘攻擊。它不是自動戰鬥偵測，而是讓公會成員在攻擊後配合人工確認的營運輔助頁面。', '在回合結束前，管理者可以更快知道誰還有攻擊、哪一隊需要提醒，並搭配公會聊天進行指揮。'] },
        { title: '使用方式與注意事項', paragraphs: ['選擇國家、公會、我方或敵方後，即可查看對象成員與攻擊狀態。資料取得可能需要時間，遊戲端更新也不一定會立即反映。', '此資訊是策略判斷的輔助。重要對戰請同時確認遊戲內畫面、公會聊天與實際攻擊結果。'] }
      ]
    },
    rangersBook: {
      summaryLabel: '閱讀 Ranger 圖鑑說明',
      sections: [
        { title: 'Ranger 圖鑑連結的用途', paragraphs: ['Ranger 圖鑑會列出 Ranger 的資源 ID、更新日期、縮圖與詳細頁連結，方便尋找新增或近期更新的 Ranger。', '縮圖是為了輔助識別。此頁的主要目的不是轉載圖片，而是整理 ID 與更新訊號，讓玩家更快前往需要的詳細資訊。'] },
        { title: '資料閱讀方式', paragraphs: ['列表中的日期是根據可取得的資源資訊推估的更新參考，不一定等同於遊戲內實裝日或平衡調整日。', '若圖片無法顯示，可能是外部資源限制、資料尚未公開或 URL 變更。必要時請使用詳細連結並搭配遊戲內資訊確認。'] }
      ]
    },
    raidHittingCharacters: {
      title: '對 Raid 有效的角色',
      lead: '公開列出擁有可影響 Raid 目標技能的 Ranger。',
      summaryLabel: '閱讀 Raid 命中判定說明',
      sections: [
        { title: '此頁提供的資訊', paragraphs: ['此頁整理擁有暈眩、解除無敵、降低技能抵抗等 Raid 相關效果的 Ranger。', '它不是單純圖片圖鑑，而是將 Raid 相關資料中抽出的技能資訊依角色整理，方便玩家尋找編隊候選與角色定位。', '同一個 Ranger 也可能因進化階段不同而有不同判定。有些 Ranger 的超進化技能會命中 Raid Boss，但究極進化技能不會命中，例如艾連、吉他手 Moon 等。'] },
        { title: '資料注意事項', paragraphs: ['顯示技能基於已收集資料，可能因遊戲更新、取得時間或未收集資料而與最新狀態不同。', '圖片僅作為 Ranger 識別輔助。重要判斷請搭配遊戲內資訊確認。'] }
      ]
    },
    about: {
      title: 'About',
      lead: 'LINE Rangers Analytics 是為 LINE Rangers 玩家製作的非官方資料分析網站。',
      sections: [
        { title: '營運目的', paragraphs: ['本站整理 PVP 與公會戰中的 Ranger、裝備與攻擊狀態，協助玩家進行編隊與公會營運判斷。', '本站不取代官方公告或遊戲內顯示，而是以玩家角度把資料整理成容易閱讀的輔助工具。'] },
        { title: '資料與關係', paragraphs: ['排名與列表是根據可取得資料整理而成，可能因取得時間、API 回應或遊戲更新與實際狀態不同。', 'LINE Rangers 及相關名稱、圖片、商標、著作物權利歸各權利者所有。本站與 LINE、LY Corporation、LINE Rangers 營運團隊無關。'] }
      ]
    },
    privacyPolicy: {
      title: '隱私權政策',
      lead: '本頁說明本站使用的存取資訊、Cookie、廣告與分析服務。',
      sections: [
        { title: '分析與紀錄', paragraphs: ['為改善網站與調查問題，本站可能取得存取時間、瀏覽頁面、瀏覽器、OS、裝置種類、IP 位址等技術資訊。這些資訊不會用於直接識別個人。', '本站可能使用 Google Analytics 等分析服務，這些服務可能透過 Cookie 等技術統計使用情況。'] },
        { title: '廣告與 Cookie', paragraphs: ['本站可能使用 Google AdSense 等第三方廣告服務。廣告服務提供者可能使用 Cookie、網路信標、IP 位址與其他識別子來投放及衡量廣告。', '使用者可以透過瀏覽器設定與 Google 廣告設定管理 Cookie 與個人化廣告。'] },
        { title: '聯絡', paragraphs: ['關於內容、權利或隱私的問題，請透過 Contact 頁面的聯絡方式提出。必要時會檢討修正、刪除或隱藏內容。'] }
      ]
    },
    contact: {
      title: 'Contact',
      lead: '如需詢問、更新資訊或修正請求，請使用以下聯絡方式。',
      sections: [
        { title: '聯絡方式', paragraphs: [`一般詢問與更新資訊請使用 X: ${sharedContactUrl}`, '修正、刪除或權利相關請求，請附上目標 URL、問題內容與可確認資訊。'] },
        { title: '處理方針', paragraphs: ['不一定能回覆所有訊息，但會優先確認網站品質問題、錯誤資訊與權利者請求。', '本站不接受廣告點擊、廣告操作或排名操作相關請求。'] }
      ],
      linkLabel: '在 X 聯絡'
    },
    disclaimer: {
      title: '免責聲明',
      lead: '本頁說明本站定位、權利標示與資訊使用限制。',
      sections: [
        { title: '非官方網站', paragraphs: ['本站是 LINE Rangers 的非官方玩家分析網站，與 LINE、LY Corporation、LINE Rangers 營運團隊或官方合作夥伴無關。', '遊戲名稱、角色名稱、圖片、商標及其他相關權利歸各權利者所有。圖片僅作為說明與導覽的輔助識別。'] },
        { title: '資訊正確性', paragraphs: ['本站資料與分析基於可取得資訊製作，但不保證正確性、完整性或即時性。', '因使用本站資訊造成的遊戲內結果、公會營運判斷或其他損害，本站營運者不負責。重要資訊請搭配遊戲內官方顯示確認。'] }
      ]
    }
  }
};

publicContent.th = {
  pages: {
    home: {
      summaryLabel: 'อ่านคำอธิบายเว็บไซต์',
      sections: [
        { title: 'สิ่งที่เว็บไซต์นี้ให้ข้อมูล', paragraphs: ['LINE เรนเจอร์ Analytics เป็นเว็บไซต์วิเคราะห์ข้อมูลแบบไม่เป็นทางการสำหรับผู้เล่น LINE เรนเจอร์ โดยจัดระเบียบข้อมูลเรนเจอร์ อุปกรณ์ และสถานะการโจมตีใน Guild War/PVP ให้ดูง่ายขึ้น', 'หน้าสาธารณะเน้นสถิติการใช้งาน PVP เครื่องมือตรวจการโจมตี Guild War และลิงก์ Rangers Book ข้อมูลอาจเปลี่ยนตามเวลาเก็บข้อมูลและอัปเดตของเกม จึงควรตรวจสอบกับหน้าจอในเกมเมื่อเป็นเรื่องสำคัญ'] },
        { title: 'คุณค่าเฉพาะและการอัปเดต', paragraphs: ['คุณค่าหลักของเว็บไซต์นี้ไม่ใช่รูปภาพในเกม แต่เป็นการรวบรวม จัดอันดับ และอธิบายข้อมูลให้ผู้เล่นใช้ตัดสินใจได้ง่ายขึ้น รูป Ranger และอุปกรณ์ใช้เพื่อช่วยระบุตัวตนเท่านั้น', 'ข้อมูลมีการอัปเดตเป็นระยะ แต่อาจล่าช้าจาก API หรือบริการภายนอก หากพบข้อมูลผิดพลาดหรือล้าสมัย โปรดแจ้งผ่านลิงก์ติดต่อด้านล่าง'] }
      ],
      summaryLinksTitle: 'หน้าหลัก'
    },
    pvp: {
      summaryLabel: 'อ่านคำอธิบายหน้า PVP',
      sections: [
        { title: 'วิธีอ่านอันดับ PVP', paragraphs: ['หน้านี้นับจำนวน Ranger ป้องกันและอุปกรณ์ที่ผู้เล่น PVP อันดับสูงใช้งาน โดยแยกตามแรงก์ เช่น LEGEND, MASTER และ DIAMOND เพื่อดูแนวโน้มของแต่ละช่วงแรงก์ได้', 'จำนวนใช้งานสูงหมายถึงถูกเลือกบ่อยในทีมป้องกันปัจจุบัน แต่ไม่ได้แปลว่าแข็งแกร่งที่สุดเสมอไป ต้องพิจารณาบทบาท อุปกรณ์ ตัวแก้ทาง และระดับการพัฒนาของคุณด้วย'] },
        { title: 'การใช้แนวโน้มอุปกรณ์', paragraphs: ['เมื่อเลือกภาพ Ranger จะเห็นตัวอย่างอุปกรณ์ที่ใช้กับ Ranger นั้น การดูอาวุธ เกราะ และเครื่องประดับช่วยให้เข้าใจบทบาทของ Ranger มากกว่าการดูแค่ความนิยม', 'ข้อมูลอาจรีเฟรชทุกไม่กี่นาที หากหน้าโหลดอยู่ ว่าง หรือดูเก่า ให้รอสักครู่แล้วโหลดใหม่และเปรียบเทียบหลายแรงก์'] }
      ]
    },
    guildWarCount: {
      summaryLabel: 'อ่านคำอธิบายตัวตรวจการโจมตี',
      sections: [
        { title: 'จุดประสงค์ของตัวตรวจการโจมตี', paragraphs: ['เครื่องมือตรวจจำนวนโจมตี Guild War ช่วยให้กิลด์ตรวจสอบการโจมตีที่เหลือของทีมเราและทีมศัตรู เป็นเครื่องมือช่วยบริหารแบบ manual ไม่ใช่ระบบตรวจจับการต่อสู้อัตโนมัติ', 'ช่วงท้ายรอบ Guild War หัวหน้ากิลด์สามารถดูได้เร็วขึ้นว่าใครยังเหลือการโจมตีและควรแจ้งเตือนทีมใดในแชต'] },
        { title: 'วิธีใช้และข้อควรระวัง', paragraphs: ['เลือกประเทศ กิลด์ และฝั่ง ally/enemy เพื่อดูสมาชิกและสถานะการโจมตี การดึงข้อมูลอาจใช้เวลา และข้อมูลจากเกมอาจไม่ได้สะท้อนทันที', 'ใช้หน้านี้เป็นข้อมูลช่วยวางแผน สำหรับแมตช์สำคัญควรยืนยันกับหน้าจอในเกม แชตกิลด์ และผลการโจมตีจริง'] }
      ]
    },
    rangersBook: {
      summaryLabel: 'อ่านคำอธิบาย Rangers Book',
      sections: [
        { title: 'วิธีใช้ลิงก์ Rangers Book', paragraphs: ['หน้า Rangers Book แสดง resource ID วันที่อัปเดต รูปย่อ และลิงก์ไปหน้ารายละเอียด เพื่อช่วยค้นหา Ranger ใหม่หรือ Ranger ที่เพิ่งอัปเดตได้ง่ายขึ้น', 'รูปย่อใช้เป็นข้อมูลช่วยระบุตัวตน จุดประสงค์หลักคือจัดระเบียบ ID และสัญญาณการอัปเดตเพื่อพาผู้เล่นไปยังข้อมูลละเอียดได้เร็วขึ้น'] },
        { title: 'การอ่านข้อมูล', paragraphs: ['วันที่ในรายการเป็นค่าประมาณจากข้อมูล resource ที่เข้าถึงได้ อาจไม่ตรงกับวันเปิดตัวในเกมหรือวันปรับสมดุลเสมอไป', 'หากรูปไม่แสดง อาจเกิดจากข้อจำกัดของ resource ภายนอก ข้อมูลยังไม่เผยแพร่ หรือ URL เปลี่ยนไป โปรดตรวจสอบลิงก์รายละเอียดและข้อมูลในเกมเมื่อจำเป็น'] }
      ]
    },
    raidHittingCharacters: {
      title: 'ตัวละครที่มีผลกับ Raid',
      lead: 'หน้าข้อมูลสาธารณะที่แสดง Ranger ซึ่งมีสกิลส่งผลต่อเป้าหมาย Raid',
      summaryLabel: 'อ่านคำอธิบายการตัดสิน Raid hit',
      sections: [
        { title: 'สิ่งที่หน้านี้แสดง', paragraphs: ['หน้านี้รวบรวม Ranger ที่มีสกิลเกี่ยวกับ Raid เช่น stun, ลบ invincibility และลด skill resistance', 'ไม่ใช่แค่แคตตาล็อกรูปภาพ แต่เป็นการจัดระเบียบข้อมูลสกิลจากข้อมูลที่เกี่ยวข้องกับ Raid เพื่อช่วยหาตัวเลือกทีมและบทบาทของ Ranger', 'การตัดสินว่าโดน Raid Boss หรือไม่อาจต่างกันตามขั้นวิวัฒนาการ Ranger บางตัวมีสกิลขั้น Hyper Evolution ที่โดน Raid Boss แต่สกิลขั้น Ultimate Evolution ไม่โดน เช่น Eren และ Guitarist Moon เป็นต้น'] },
        { title: 'ข้อควรระวังของข้อมูล', paragraphs: ['รายการอ้างอิงจากข้อมูลที่เก็บได้ อาจแตกต่างจากสถานะล่าสุดตามอัปเดตของเกมหรือเวลาเก็บข้อมูล', 'รูปภาพใช้เพื่อช่วยระบุตัว Ranger เท่านั้น ควรตรวจสอบข้อมูลสำคัญกับหน้าจอในเกมด้วย'] }
      ]
    },
    about: {
      title: 'About',
      lead: 'LINE Rangers Analytics เป็นเว็บไซต์วิเคราะห์ข้อมูลแบบไม่เป็นทางการสำหรับผู้เล่น LINE Rangers',
      sections: [
        { title: 'วัตถุประสงค์', paragraphs: ['เว็บไซต์นี้จัดระเบียบข้อมูล Ranger อุปกรณ์ และสถานะ Guild War/PVP เพื่อช่วยผู้เล่นตัดสินใจเรื่องทีมและการบริหารกิลด์', 'เว็บไซต์นี้ไม่ใช่ประกาศทางการและไม่แทนที่ข้อมูลในเกม เป็นเพียงเครื่องมือช่วยอ่านข้อมูลจากมุมมองผู้เล่น'] },
        { title: 'ข้อมูลและความเกี่ยวข้อง', paragraphs: ['อันดับและรายการต่าง ๆ อ้างอิงจากข้อมูลที่เก็บและจัดระเบียบได้ อาจแตกต่างจากสถานะจริงตามเวลาเก็บข้อมูล API หรืออัปเดตของเกม', 'LINE Rangers ชื่อ รูปภาพ เครื่องหมายการค้า และผลงานที่เกี่ยวข้องเป็นสิทธิ์ของเจ้าของแต่ละราย เว็บไซต์นี้ไม่เกี่ยวข้องกับ LINE, LY Corporation หรือทีม LINE Rangers'] }
      ]
    },
    privacyPolicy: {
      title: 'นโยบายความเป็นส่วนตัว',
      lead: 'หน้านี้อธิบายข้อมูลการเข้าชม Cookie โฆษณา และบริการวิเคราะห์ที่เว็บไซต์ใช้',
      sections: [
        { title: 'การวิเคราะห์และบันทึก', paragraphs: ['เพื่อปรับปรุงเว็บไซต์และตรวจสอบปัญหา เว็บไซต์อาจเก็บข้อมูลทางเทคนิค เช่น เวลาเข้าชม หน้าเว็บ เบราว์เซอร์ OS ประเภทอุปกรณ์ และ IP address ข้อมูลนี้ไม่ได้ใช้เพื่อระบุตัวบุคคลโดยตรง', 'เว็บไซต์อาจใช้บริการวิเคราะห์ เช่น Google Analytics ซึ่งอาจใช้ Cookie เพื่อสรุปการใช้งาน'] },
        { title: 'โฆษณาและ Cookie', paragraphs: ['เว็บไซต์อาจใช้บริการโฆษณาจากบุคคลที่สาม เช่น Google AdSense ผู้ให้บริการโฆษณาอาจใช้ Cookie, web beacon, IP address และตัวระบุอื่นเพื่อแสดงและวัดผลโฆษณา', 'ผู้ใช้สามารถจัดการ Cookie และโฆษณาแบบปรับตามความสนใจได้ผ่านการตั้งค่าเบราว์เซอร์และการตั้งค่าโฆษณาของ Google'] },
        { title: 'ติดต่อ', paragraphs: ['สำหรับคำถามเกี่ยวกับเนื้อหา สิทธิ์ หรือความเป็นส่วนตัว โปรดใช้หน้า Contact หากเหมาะสม เราจะพิจารณาแก้ไข ลบ หรือซ่อนข้อมูล'] }
      ]
    },
    contact: {
      title: 'Contact',
      lead: 'ใช้หน้านี้สำหรับคำถาม ข่าวอัปเดต คำขอแก้ไข และเรื่องสิทธิ์',
      sections: [
        { title: 'ช่องทางติดต่อ', paragraphs: [`คำถามทั่วไปและข่าวอัปเดตติดต่อผ่าน X: ${sharedContactUrl}`, 'สำหรับการแก้ไข ลบ หรือเรื่องสิทธิ์ โปรดแนบ URL เป้าหมาย รายละเอียดปัญหา และข้อมูลที่ช่วยยืนยันคำขอ'] },
        { title: 'แนวทางการตอบกลับ', paragraphs: ['เราอาจไม่สามารถตอบทุกข้อความได้ แต่จะให้ความสำคัญกับปัญหาคุณภาพเว็บไซต์ ข้อมูลผิดพลาด และคำขอจากเจ้าของสิทธิ์', 'เราไม่รับคำขอเกี่ยวกับการคลิกโฆษณา การควบคุมโฆษณา หรือการปรับอันดับ'] }
      ],
      linkLabel: 'ติดต่อทาง X'
    },
    disclaimer: {
      title: 'ข้อจำกัดความรับผิด',
      lead: 'หน้านี้อธิบายสถานะของเว็บไซต์ สิทธิ์ และข้อจำกัดของข้อมูล',
      sections: [
        { title: 'เว็บไซต์ไม่เป็นทางการ', paragraphs: ['เว็บไซต์นี้เป็นเว็บไซต์วิเคราะห์สำหรับแฟน LINE Rangers แบบไม่เป็นทางการ ไม่เกี่ยวข้อง ไม่ได้รับการรับรอง และไม่ได้รับการสนับสนุนจาก LINE, LY Corporation, ทีม LINE Rangers หรือพาร์ทเนอร์ทางการ', 'ชื่อเกม ชื่อตัวละคร รูปภาพ เครื่องหมายการค้า และสิทธิ์ที่เกี่ยวข้องเป็นของเจ้าของแต่ละราย รูปภาพแสดงเพื่อช่วยอธิบายและนำทางเท่านั้น'] },
        { title: 'ความถูกต้องของข้อมูล', paragraphs: ['ข้อมูลและการวิเคราะห์อ้างอิงจากข้อมูลที่สามารถเก็บได้ แต่ไม่รับประกันความถูกต้อง ความครบถ้วน หรือความเป็นปัจจุบัน', 'ผู้ดูแลเว็บไซต์ไม่รับผิดชอบต่อผลในเกม การตัดสินใจบริหารกิลด์ หรือความเสียหายอื่นจากการใช้ข้อมูลนี้ โปรดยืนยันข้อมูลสำคัญกับหน้าจอในเกม'] }
      ]
    }
  }
};

const localeFallbacks = {
  ko: 'en',
  'zh-tw': 'en',
  th: 'en'
};

const getPublicContent = (locale) => {
  const targetLocale = publicContent[locale] ? locale : localeFallbacks[locale] || 'en';
  return publicContent[targetLocale];
};

const getContentPage = (locale, key) => {
  return getPublicContent(locale).pages[key] || publicContent.en.pages[key];
};

const getTrustPageEntries = (locale) => {
  const content = getPublicContent(locale);
  return Object.entries(TRUST_PAGE_ROUTES).map(([path, key]) => ({
    path,
    key,
    title: content.pages[key].title
  }));
};

module.exports = {
  CONTENT_ROUTES,
  TRUST_PAGE_ROUTES,
  publicContent,
  getContentPage,
  getPublicContent,
  getTrustPageEntries
};
